<template>
  <v-flex class="mb-5" v-scroll="onScroll">
    <v-layout justify-space-between align-baseline>
      <v-flex d-flex align-center v-if="haveSearchBox">
        <slot name="beforeSearchBox"></slot>
        <v-flex v-if="showSearchBoxLabel" md10 :offset-md1="$slots.beforeSearchBox">
          <v-text-field
            :label="searchBoxLabel"
            v-model="searchValue"
            :hint="searchBoxHint"
            :disabled="loading"
            clearable
            @keyup.enter="$$initiateTable"></v-text-field>
        </v-flex>
      </v-flex>
      <v-flex>
        <slot name="beforeMenu"></slot>
      </v-flex>
      <v-flex md6 d-flex justify-end align-center>
        <v-flex md5 v-if="isPaymentTenant">
          <v-switch
            :label="$t(searchDateSwitch ? 'searchByEstimateDate' : 'searchByCreateDate')"
            v-model="searchDateSwitch"
            :disabled="loading"
          ></v-switch>
        </v-flex>
        <v-flex v-if="hasTimeZoneSearchBox">
          <v-select
            :items="timeZones"
            v-model="timeZone"
            :label="$t('timeZone')"
            style="min-width: 100px"
          ></v-select>
        </v-flex>
        <v-flex :style="{'min-width': `${isShowStartBtn ? '240px' : '140px'}`}" md3  v-if="haveStartDate">
          <v-menu
            :close-on-content-click="false"
            v-model="startMenu"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            :disabled="loading"
          >
            <template v-slot:activator="data">
              <v-layout>
                <v-text-field
                  style="min-width: 105px"
                  v-model="startDateFormatted"
                  :label="startDateLabel"
                  prepend-icon="event"
                  readonly
                  align-end
                  v-on="data.on"
                ></v-text-field>
                <v-btn v-if="isShowStartBtn" small style="margin-top:20px" color="primary" @click="SearchByCurrentTime" light>
                  {{$t('currentTime')}}
                </v-btn>
              </v-layout>
            </template>
            <v-date-picker :min="minDate" :max="maxDate" v-model="startDateString" @input="startMenu = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex style="min-width:140px" md3  v-if="!haveNoEndDate">
          <v-menu
            :close-on-content-click="false"
            v-model="endMenu"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            :disabled="loading"
          >
            <template v-slot:activator="data">
              <v-text-field
                style="min-width: 105px"
                v-model="endDateFormatted"
                :label="endDateDisplayLabel"
                prepend-icon="event"
                readonly
                v-on="data.on"
              ></v-text-field>
            </template>
            <v-date-picker :min="minDate" :max="maxDate" v-model="endDateString" @input="endMenu = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex md3>
          <v-btn small color="primary" @click="onDateSubmit" :disabled="loading">{{ searchText || $t('search') }}</v-btn>
        </v-flex>
        <slot name="afterDate"></slot>
      </v-flex>
      <v-flex xs8 md2 v-if="canSearch">
        <v-text-field
          append-icon="filter_list"
          label="search"
          single-line
          hide-details
          v-model="filter"
          :disabled="loading"
          clearable
        ></v-text-field>
      </v-flex>
    </v-layout>
    <div class="slotTable"><slot name="dataTable" :isLoadedToEnd="isLoadedToEnd"></slot></div>
    <v-layout class="pagination" justify-center align-center v-if="isPagination && !disabledFooter">
      <v-btn
        small
        color="primary"
        @click="startGetData('start')"
        :disabled="startBtnDisabled"
        v-if="!isApi"
      >
        {{ $t('startPage') }}
      </v-btn>
      <v-btn
        small
        color="primary"
        @click="startGetData('prev')"
        :disabled="startBtnDisabled"
      >
        <v-icon>navigate_before</v-icon>
      </v-btn>
      <label v-show="!isDesc">{{ $t('pagination', { page }) }}</label>
      <v-btn
        small
        color="primary"
        @click="startGetData('next')"
        :disabled="endBtnDisabled"
      >
        <v-icon>navigate_next</v-icon>
      </v-btn>
      <v-btn
        small
        color="primary"
        @click="startGetData('end')"
        :disabled="endBtnDisabled"
        v-if="!isApi"
      >
        {{ $t('endPage') }}
      </v-btn>
      <v-select
        :items="pages"
        v-model="limit"
        style="width: 70px"
        @change="changePageLimit"
      ></v-select>
    </v-layout>
    <v-layout justify-center v-else>
      <v-progress-circular v-if="loading" color="blue" indeterminate></v-progress-circular>
    </v-layout>
  </v-flex>
</template>

<script>
import { toDateEnd, toDateStart, convertTimestampToDateInObj, toPickerDateString, format } from '../utils/tools'
// TODO this component needs further integration.
export default {
  name: 'PaginationController',
  data () {
    const beginDate = this.haveStartDate
      ? this.startDate
        ? toPickerDateString(this.startDate)
        : '2021-01-01'
      : '2018-10-01'
    return {
      loading: false,
      startDateString: beginDate,
      startDateFormatted: this.haveStartDate ? this.formatDate(beginDate) : this.formatDate(beginDate),
      startMenu: false,
      endDateString: toPickerDateString(new Date()),
      endDateFormatted: this.formatDate(toPickerDateString(new Date())),
      endMenu: false,
      endDocLocal: {},
      endDocArrayLocal: [],
      startDocLocal: {},
      startDocArrayLocal: [],
      filter: '',
      payload: {},
      endDocArrayLocalAllResolved: true,
      searchValue: this.initSearchValue || '',
      searchDateSwitch: false,
      page: 1,
      isEndDisabled: false,
      isStartDisabled: false,
      cacheData: [],
      isDesc: false,
      limit: this.pages?.[0] || 25,
      maxPage: 0
    }
  },
  created () {
    this.payload = {}
    if (this.startDate && !this.haveNoEndDate && this.haveStartDate) {
      this.onDateSubmit()
    } else {
      this.isStartWithoutData || this.$$initiateTable()
    }
    this.getPaginationDataOutside && (this.endDocArrayLocalAllResolved = false)
  },
  computed: {
    timeZone: {
      get () {
        return this.zoneType || '0'
      },
      set (val) {
        this.$emit('update:zoneType', val)
      }
    },
    timeZones () {
      return [
        {
          text: this.$t('currentZone'),
          value: '0'
        },
        {
          text: this.$t('UTC'),
          value: '1'
        }
      ]
    },
    startBtnDisabled () {
      return this.isStartDisabled || (!this.isDesc && this.page === 1) || this.loading
    },
    endBtnDisabled () {
      return this.isEndDisabled || (this.isDesc && this.page === 1) || this.loading
    },
    isLoadedToEnd () {
      return !(this.loading === false && (!this.endDocArrayLocalAllResolved || (this.endDocLocal && (this.endDocLocal.exists || (this.isApi && this.endDocLocal.sk)))))
    },
    endDateDisplayLabel () {
      return this.endDateLabel || (this.searchDateSwitch ? this.$t('estimateDate') : this.$t('endDate'))
    }
  },
  watch: {
    filter (value) {
      this.toParentFilter(value)
    },
    startDateString (value) {
      this.startDateFormatted = this.formatDate(this.startDateString)
    },
    endDateString (value) {
      this.endDateFormatted = this.formatDate(this.endDateString)
    },
    checkBox (value) {
      this.$$initiateTable()
    },
    select (value) {
      if (this.isRefreshSelect) {
        this.$$initiateTable()
      }
    },
    outsideScrollToBottom (value) {
      if (value && (this.loading === false) && (!this.endDocArrayLocalAllResolved || (this.endDocLocal && (this.endDocLocal.exists || (this.isApi && this.endDocLocal.sk))))) {
        this.startGetData()
      }
    },
    refresh () {
      this.$$initiateTable()
    },
    loading (value) {
      this.$emit('setLoading', value)
    }
  },
  methods: {
    changePageLimit () {
      if (!this.isPagination) return
      const diffPage = this.cacheData.length - this.limit
      if (diffPage >= 0) {
        this.isEndDisabled = false
        this.isStartDisabled = false
        this.page = 1
        this.$emit('input', this.cacheData.slice(0, this.limit))
      } else {
        this.startGetData(this.isDesc ? 'end' : 'start')
      }
    },
    SearchByCurrentTime () {
      const timeStr = new Date().toISOString().slice(0, 10)
      this.startDateString = timeStr
      this.startDateFormatted = this.formatDate(timeStr)
      this.onDateSubmit()
    },
    $$initiateTable () {
      if (this.loading) return
      this.$emit('input', [])
      if (this.hasTimeZoneSearchBox && +this.timeZone === 1) {
        let { startDate, endDate } = this.payload
        if (startDate) this.payload.startDate = new Date(format(this.payload.startDate, 'yyyy-MM-dd') + 'T00:00:00.000Z')
        if (endDate) {
          this.payload.endDate = new Date(
            new Date(format(this.payload.endDate, 'yyyy-MM-dd') + 'T00:00:00.000Z').getTime() - 1
          )
        }
      }
      this.payload.startAfter && (delete this.payload.startAfter)
      this.loading = true
      if (this.getPaginationDataOutside) {
        this.getDataFromMultiCollections()
      } else {
        this.getPaginationData(this.payload)
      }
    },
    getDataFromMultiCollections () {
      this.addPredicatesToPayload(this.payload)

      this.getPaginationDataOutside(this.payload)
        .then(endDocArray => {
          if (!endDocArray) return
          this.endDocArrayLocal = endDocArray
          this.endDocArrayLocalAllResolved = this.endDocArrayLocal.reduce((result, item) => {
            return result && (item === 'resolved')
          }, true)
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          console.log(error.message)
        })
    },
    onScroll (e) {
      if (this.isPagination) return
      let height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      let scrollTop = document.documentElement.scrollTop === 0 ? document.body.scrollTop : document.documentElement.scrollTop
      let scrollHeight = document.documentElement.scrollTop === 0 ? document.body.scrollHeight : document.documentElement.scrollHeight
      if ((Math.abs(height + scrollTop - scrollHeight) <= 2) && !this.isLoadedToEnd) {
        this.startGetData()
      }
    },
    startGetData (type, limit) {
      if (this.isPagination && type) {
        if (['start', 'end'].includes(type)) this.initConfig(type)
        if (this.isDesc && ['next', 'prev'].includes(type)) type = type === 'prev' ? 'next' : 'prev'
      }
      this.loading = true
      this.payload.startAfter = this.endDocArrayLocal.length === 0 ? this.endDocLocal : this.endDocArrayLocal
      this.payload.endBefore = this.startDocArrayLocal.length === 0 ? this.startDocLocal : this.startDocArrayLocal
      if (this.getPaginationDataOutside) {
        this.getDataFromMultiCollections()
      } else {
        this.getPaginationData(this.payload, type, limit)
      }
    },
    addPredicatesToPayload (payload) {
      payload.predicates = {}
      this.checkBox && (payload.predicates.predicateCheckBox = true)
      this.select && (payload.predicates.predicateSelect = this.select)
      this.searchValue && (payload.predicates.predicateText = this.getSearchValue())
      this.searchDateSwitch && (payload.predicates.predicateSwitch = this.searchDateSwitch)
      this.actionPredicates && this.actionPredicates.length !== 0 && (payload.predicates.actionPredicates = this.actionPredicates)
    },
    getPaginationData (payload, type = this.isPagination ? 'start' : '', limitPage) {
      const typesMap = {
        start: 1,
        next: this.page + 1,
        prev: this.page - 1,
        end: 1
      }
      if (payload) {
        this.isPagination
          ? payload.limit = limitPage || this.limit
          : payload.limit || (payload.limit = this.historyLimit)
      }
      this.addPredicatesToPayload(payload)
      if (this.actionPayload) {
        payload.actionPayload = this.actionPayload
      }
      if (this.isUsingModelInAction) {
        return this.$store.dispatch(this.getDataActionName, payload)
          .then(({models, docs}) => {
            if (models) {
              let newData = [...this.value, ...models]
              let endDoc = docs.docs[docs.docs.length - 1]
              if (Array.isArray(endDoc)) {
                this.endDocArrayLocal = endDoc
              } else {
                this.endDocLocal = endDoc
              }
              if (this.filterFunction) {
                let originLength = newData.length
                newData = this.filterFunction(newData)
                let filterNum = originLength - newData.length
                if (filterNum && newData.length < limit) {
                  this.startGetData()
                }
              }
              this.loading = false
              this.$emit('input', newData)
            }
          })
          .catch((error) => {
            this.loading = false
            console.log(error.message)
            if (error.message.includes('maximum of 10 elements in the value array')) {
              alert(this.$t('maximumErrorMessage'))
            }
          })
      }

      // const isDescNext = this.isDesc && type === 'next'
      const isAdd = !type || (type === 'next' && this.isPagination)
      const limit = payload.limit
      const newPage = typesMap[type]

      if (this.isPagination) {
        const cacheStartLimit = (newPage - 1) * limit
        const cacheEndLimit = newPage * limit
        const paginationCache = this.cacheData.slice(cacheStartLimit, cacheEndLimit)
        if (paginationCache.length) {
          const isEnd = this.maxPage === newPage
          Object.assign(this, {
            isStartDisabled: this.isDesc && isEnd,
            isEndDisabled: !this.isDesc && isEnd,
            page: newPage
          })
          this.$emit('input', this.isDesc ? paginationCache.reverse() : paginationCache)
          this.loading = false
          return
        }
      }
      if (this.isPagination) Object.assign(payload, { type, isDesc: this.isDesc })
      return this.$store.dispatch(this.getDataActionName, { ...payload })
        .then(docs => {
          if (this.isApi) {
            if (!this.page) this.page = 1
            const { data, startKey } = docs.data
            const isEnd = data.length < limit || !startKey
            const isNoData = !startKey && data.length === 0
            const endDocName = 'endDocLocal'

            const cacheData = this.isPagination
              ? this.cacheData
              : this.value
            let newData = !isAdd ? [...data, ...cacheData] : [...cacheData, ...data]
            Object.assign(this, {
              [endDocName]: startKey,
              isStartDisabled: this.isDesc && isEnd,
              isEndDisabled: !this.isDesc && isEnd
            })
            this.loading = false
            let value = []
            if (this.isPagination) {
              const startLimit = (newPage - 1) * limit
              const endLimit = newPage * limit
              this.cacheData.push(...data)
              value = newData.slice(startLimit, endLimit)
              if (isEnd) {
                this.maxPage = Math.ceil(this.cacheData.length / limit)
                this.$store.dispatch('showToast', { info: this.$t('endData'), level: 'info' })
              }
            } else {
              value = newData
            }
            if (!isNoData) this.$emit('input', this.isDesc ? value.reverse() : value)
            if (!this.isPagination && newData.length < (this.page * limit) && startKey?.sk) {
              this.startGetData()
            } else {
              this.page += 1
            }
          } else if (docs) {
            let data = []
            let endDoc = docs.docs[docs.docs.length - 1]
            let startDoc = docs.docs[0]
            docs.forEach(doc => {
              const obj = convertTimestampToDateInObj(doc.data())
              obj.paginationKey = doc.id
              obj._key = doc.id
              if (typeof this.handleData === 'function') {
                const result = this.handleData(obj)
                Array.isArray(result) ? data.push(...result) : data.push(result)
              } else {
                data.push(obj)
              }
            })
            const cacheData = this.isPagination
              ? this.cacheData
              : this.value
            let newData = !isAdd ? [...data, ...cacheData] : [...cacheData, ...data]
            const endDocName = Array.isArray(endDoc) ? 'endDocArrayLocal' : 'endDocLocal'
            const startDocName = Array.isArray(startDoc) ? 'startDocArrayLocal' : 'startDocLocal'
            const isEnd = data.length < limit
            const isNoData = data.length === 0
            Object.assign(this, {
              [endDocName]: endDoc,
              [startDocName]: startDoc,
              isStartDisabled: this.isDesc && isEnd,
              isEndDisabled: !this.isDesc && isEnd,
              page: isNoData ? this.page : typesMap[type]
            })
            this.loading = false

            if (this.filterFunction && !isEnd) {
              let originLength = newData.length
              newData = this.filterFunction(newData)
              let filterNum = originLength - newData.length
              if (filterNum && newData.length < limit) {
                this.startGetData()
              }
            }
            let value = []
            if (this.isPagination) {
              const startLimit = (newPage - 1) * limit
              const endLimit = newPage * limit
              this.cacheData.push(...data)
              value = newData.slice(startLimit, endLimit)
              if (isEnd) {
                this.maxPage = Math.ceil(this.cacheData.length / limit)
                this.$store.dispatch('showToast', { info: this.$t('endData'), level: 'info' })
              }
            } else {
              value = newData
            }
            if (!isNoData) this.$emit('input', this.isDesc ? value.reverse() : value)
          }
        })
        .catch((error) => {
          this.loading = false
          console.log(error.message)
        })
    },
    toDateFormString (timestamp) {
      return timestamp && toDateEnd(timestamp)
    },
    toDateFormStart (timestamp) {
      return timestamp && toDateStart(timestamp)
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    initConfig (type) {
      this.page = 1
      this.isEnd = false
      this.endDocLocal = {}
      this.endDocArrayLocal = []
      this.startDocLocal = {}
      this.startDocArrayLocal = []
      this.isEndDisabled = false
      this.isStartDisabled = false
      this.cacheData = []
      this.isDesc = type === 'end'
      this.maxPage = 0
    },
    getPayload () {
      this.initConfig()
      const isSearchDate = !this.haveNoEndDate || this.haveStartDate
      const startDate = this.searchDateSwitch
        ? this.toDateFormStart(new Date(this.endDateString.replace(/-/g, '/')))
        : new Date(Date.parse(this.startDateString.replace(/-/g, '/')))
      this.payload = {
        ...this.payload,
        startDate,
        endDate: this.toDateFormString(new Date(this.endDateString.replace(/-/g, '/'))),
        limit: this.historyLimit
      }
      if (!isSearchDate) {
        delete this.payload.startDate
        delete this.payload.endDate
      }
      return { ...this.payload }
    },
    onDateSubmit () {
      this.initConfig()
      const isSearchDate = !this.haveNoEndDate || this.haveStartDate
      const startDate = this.searchDateSwitch
        ? this.toDateFormStart(new Date(this.endDateString.replace(/-/g, '/')))
        : new Date(Date.parse(this.startDateString.replace(/-/g, '/')))
      this.payload = {
        ...this.payload,
        startDate,
        endDate: this.toDateFormString(new Date(this.endDateString.replace(/-/g, '/'))),
        limit: this.historyLimit
      }
      if (!isSearchDate) {
        delete this.payload.startDate
        delete this.payload.endDate
      }
      this.$$initiateTable(this.payload)
    },
    getSearchValue () {
      if (this.keepKeywordCase) {
        return this.searchValue.trim()
      }
      if (this.keywordToUpperCase) {
        return this.searchValue.trim().toUpperCase()
      }
      return this.searchValue.trim().toLowerCase()
    }
  },
  props: {
    value: Array,
    getPaginationDataOutside: Function,
    filterFunction: Function,
    getDataActionName: String,
    actionPredicates: Array,
    historyLimit: Number,
    toParentFilter: Function,
    canSearch: Boolean,
    haveStartDate: Boolean,
    startDateLabel: {
      type: String,
      default () { return this.$t('startDate') }
    },
    endDateLabel: String,
    haveNoEndDate: Boolean,
    actionPayload: Object,
    outsideScrollToBottom: Boolean,
    checkBox: Boolean,
    select: String,
    isRefreshSelect: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    haveSearchBox: Boolean,
    searchBoxLabel: String,
    searchBoxHint: String,
    isPaymentTenant: Boolean,
    refresh: Boolean,
    isUsingModelInAction: Boolean,
    keywordToUpperCase: Boolean,
    keepKeywordCase: Boolean,
    isStartWithoutData: Boolean,
    handleData: Function,
    initSearchValue: {
      type: String,
      default: ''
    },
    showSearchBoxLabel: {
      type: Boolean,
      default: true
    },
    isShowStartBtn: {
      type: Boolean,
      default: false
    },
    isHideSearchBtn: {
      type: Boolean,
      default: false
    },
    isPagination: {
      type: Boolean,
      default: false
    },
    startDate: {
      type: Date || null,
      default: null
    },
    disabledFooter: {
      type: Boolean,
      default: false
    },
    searchText: {
      type: String,
      default: ''
    },
    pages: {
      type: Array,
      default: () => [25, 50, 100]
    },
    hasTimeZoneSearchBox: {
      type: Boolean,
      default: false
    },
    zoneType: {
      type: Number | String,
      default: 0
    },
    isApi: {
      type: Boolean,
      default: false
    },
    maxDate: {
      type: Date | null,
      default: null
    },
    minDate: {
      type: Date | null,
      default: null
    }
  }
}
</script>

<style scoped>
  .pagination {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/components/PaginationController.vue